module.exports = __webpack_public_path__ + "img/header-weddingRingsCertificate.e6e449f.webp";